import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, inject } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { PositionSettingsInterface } from '@shared/components/trading/widgets/positions-widget/core/interfaces/position-settings.interface'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { AssetClassEnum } from '@modules/positions-module/enums/asset-class.enum'
import { DropdownColumnsActionsComponent } from '@shared/components/trading/widgets/common/dropdown-columns-actions/dropdown-columns-actions.component'
import { ColumnInterface } from '@shared/interfaces/column.interface'
import { PositionColumnsEnum } from '@shared/components/trading/widgets/positions-widget/core/enums/position-columns.enum'
import { PositionsOptionsColumnsEnum } from '@shared/components/trading/widgets/positions-widget/core/enums/positions-options-columns.enum'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'

@UseLocales({ ru, en })
@Component({
	selector: 'app-dropdown-columns-positions',
	templateUrl: './dropdown-columns-positions.component.html',
	styleUrl: './dropdown-columns-positions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DropdownColumnsActionsComponent],
})
export class DropdownColumnsPositionsComponent {
	protected readonly assetClassEnum: typeof AssetClassEnum = AssetClassEnum

	public widget: InputSignal<WidgetInterface<PositionSettingsInterface> | null> =
		input<WidgetInterface<PositionSettingsInterface> | null>(null)

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected stocksColumns: Signal<ColumnInterface<PositionColumnsEnum>[]> = computed<
		ColumnInterface<PositionColumnsEnum>[]
	>((): ColumnInterface<PositionColumnsEnum>[] => {
		const widget: WidgetInterface<PositionSettingsInterface> | null = this.widget()

		return widget?.settings.stocks.columns ?? []
	})

	protected optionsColumns: Signal<ColumnInterface<PositionsOptionsColumnsEnum>[]> = computed<
		ColumnInterface<PositionsOptionsColumnsEnum>[]
	>((): ColumnInterface<PositionsOptionsColumnsEnum>[] => {
		const widget: WidgetInterface<PositionSettingsInterface> | null = this.widget()

		return widget?.settings.options.columns ?? []
	})
	protected onChangeStocksColumns(columns: ColumnInterface<PositionColumnsEnum>[]): void {
		const widget: WidgetInterface<PositionSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				stocks: { columns },
			},
		})
	}

	protected onChangeOptionsColumns(columns: ColumnInterface<PositionsOptionsColumnsEnum>[]): void {
		const widget: WidgetInterface<PositionSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				options: { columns },
			},
		})
	}
}
